module.exports = __webpack_public_path__ + "static/Panna-Cotta-f0ae883485cdfa9d753ee181a892aca5.png";